export const setupconfirmationdata = [
  { value: "Trendline" },
  { value: "Psycology Level" },
  { value: "Chart Partern" },
  { value: "High And Low" },
  { value: "Break Of Structure" },
];

export const outcomedata = [{ value: "Profit" }, { value: "Loss" }];
